var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 12.2307,
    r: 11.5769,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.375 5.83179H14.3768V5.82919C14.3768 5.36919 14.0137 4.99756 13.5643 4.99756H9.43574C8.98633 4.99756 8.62324 5.36919 8.62324 5.82919V5.83179H6.625C6.17559 5.83179 5.8125 6.20342 5.8125 6.66342C5.8125 7.12342 6.17559 7.49505 6.625 7.49505H16.375C16.8244 7.49505 17.1875 7.12342 17.1875 6.66342C17.1875 6.20342 16.8244 5.83179 16.375 5.83179Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0623 19.005H7.93768C7.21659 19.005 6.63007 18.4073 6.63007 17.6666V9.66214C6.63007 8.92406 7.21405 8.32373 7.93768 8.32373H15.042C15.7758 8.32373 16.3699 8.93186 16.3699 9.68293V17.6666C16.3674 18.4047 15.7834 19.005 15.0623 19.005Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.1bdd3669.svg";
export { ForwardRef as ReactComponent };